<template>
    <div class="cert">
        <div class="title">我的订单</div>
        <div class="table">
            <el-table :data="tableData" style="width: 100%" id="orderTable">
                <el-table-column prop="orderNum" label="订单编号" width="170">
                </el-table-column>
                <el-table-column prop="shopName" label="产品/服务" width="110">
                </el-table-column>
                <el-table-column prop="price" label="价格">
                </el-table-column>
                <el-table-column prop="long" label="单位">
                </el-table-column>
                <el-table-column prop="ct" label="下单时间" width="200">
                </el-table-column>
                    <el-table-column prop="type" label="支付渠道" width="106">
                        <template slot-scope="scopeType">
                            <div class="tableScope">
                                <span v-if="scopeType.row.orderChannel === '0'">支付宝</span>
                                <span v-if="scopeType.row.orderChannel === '1'">微信</span>
                            </div>
                        </template>
                    </el-table-column>
                <el-table-column prop="money" label="实付款">
                </el-table-column>
                <el-table-column label="订单操作" width="180">
                    <template slot-scope="scope">
                        <div class="tableScope">
                            <div class="tableBtn" @click="handlPay(scope.row)" v-show="scope.row.orderState === '0'">
                                订单支付
                            </div>
                            <div class="tableBtn" v-show="scope.row.orderState === '1'">已支付</div>
                            <div class="tableBtn" @click="handlCener(scope.row)" v-show="scope.row.orderState === '0'">
                                取消订单
                            </div>
                            <div class="tableBtn" v-show="scope.row.orderState === '2'">已取消</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- <el-button type="text" @click="open">点击打开 Message Box</el-button> -->
            <div v-html="html" v-show="false"></div>
        </div>
    </div>
</template>

<script>
    import {
        Loading
    } from 'element-ui';

    export default {
        data() {
            return {
                tableData: [],
                html: ''
            }
        },
        watch: {
            html(newVal, oldVal) {
                console.log(newVal)
                this.html = newVal
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            Loading() {
                Loading.service({
                    lock: true,
                    text: '加载中.....',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    spinner: 'my-el-custom-spinner',
                });
            },
            handlPay(row) {
                let _this = this;
                let param = new FormData();
                param.append('orderId', row.id);
                param.append('token', _this.$global.token);
                if (row.orderChannel == 0) {
                    _this.api.aliPay(param).then(res => {
                        console.log(res)
                        this.html = res.data;
                        setTimeout(() => {
                            document.forms[0].submit();
                        }, 100)
                    }).catch((res) => {
                        this.$message({
                            message: '支付宝支付失败',
                            type: 'error'
                        })
                    })
                } else {
                    _this.api.wxPay(param).then(res => {
                        console.log(res)
                        let img = res.data
                        this.$alert(
                            `<img src='data:image/png;base64,${img}' style="width:100%;height:100%;object-fit: cover;" />`,
                            '微信支付', {
                                dangerouslyUseHTMLString: true,
                                // showConfirmButton: false,
                                customClass: 'myAlert',
                                confirmButtonClass: 'classPay',
                                confirmButtonText: '支付完成',
                                callback(e) {
                                    console.log(e)
                                    let formData = new FormData();
                                    formData.append('token', _this.$global.token);
                                    formData.append('orderId', row.id);
                                    _this.api.getPaytime(formData).then(res => {
                                        console.log("支付会掉", res)
                                        if (res.code == 1) {
                                            _this.$message.error('支付失败');
                                            _this.getData();
                                        } else {
                                            _this.$message.success('支付成功');
                                            setTimeout(() => {
                                                location.reload()
                                            }, 500)
                                        }

                                    }).catch(e => {
                                        console.log(e);

                                    })
                                }
                            });
                    }).catch((res) => {
                        this.$message({
                            message: '微信支付失败',
                            type: 'error'
                        })
                    })
                }
            },
            handlCener(row) {
                let _this = this;
                let param = new FormData();
                param.append('token', _this.$global.token);
                param.append('id', row.id);
                _this.api.cancelOrder(param).then(res => {
                    console.log(res);
                    _this.$message.success('已取消')
                    _this.getData();
                })
            },
            getData() {
                let _this = this;
                let param = new FormData();
                param.append('token', _this.$global.token);
                _this.api.getOrderList(param).then(res => {
                    console.log(res);
                    _this.tableData = res.data;
                    _this.tableData.forEach(item => {
                        if (item.timeLimit) {
                            item.long = item.timeLimit + "天"
                        }
                        if (item.useLimit) {
                            item.long = item.useLimit + "次"
                        }
                        if (item.orderState === '0') {
                            item.money = "未支付"
                        } else if (item.orderState === '1') {
                          item.money = item.price
                          item.moneys = '已支付'
                        } else if (item.orderState === '2') {
                            item.money = "已取消"
                        } else {
                            item.money = item.price
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #orderTable .tableScope {
        width: @a;
        height: @a;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    #orderTable .tableBtn:first-child {
        margin-left: 0;
    }

    #orderTable .tableBtn {
        padding: 2px 6px;
        margin-left: 10px;
        background-color: #fff;

        border-radius: 15px;
        border: solid 1px #aaaaaa;
        font-size: 14px;
        cursor: pointer;
        color: #333333 !important;
    }

    #userDialog /deep/ .el-dialog--center .el-dialog__body {
        padding-top: 0;
    }

    #userDialog /deep/ .el-dialog--center {
        border-radius: 30px;
    }

    #userDialog /deep/ .el-dialog__header {
        padding: 0;
        width: @a;
        height: 100px;
    }

    #userDialog /deep/ .el-dialog__title {
        width: @a;
        height: 100px;
        text-align: center;
        font-family: MicrosoftYaHei-Bold;
        font-size: 36px !important;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #333333 !important;
        line-height: 100px;
    }

    #userDialog .dialogUser {
        width: @a;
        height: 60px;
        margin-top: 30px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;
        }
    }

    #userDialog .dialogEmPh {
        width: @a;
        height: 60px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;

        }
    }

    #userDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        letter-spacing: 1px;
        color: #fff;
        line-height: 80px;
        text-align: center;
        margin-top: 30px;
        cursor: pointer;

    }

    #orderTable /deep/ .el-table__body tr:hover > td {
        background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
        color: #fff;
    }

    #orderTable /deep/ .el-input__inner {
        width: 120px;
        height: 30px;
        margin-left: 15px;
    }

    #orderTable /deep/ .el-input__icon {
        line-height: 30px;
    }

    #orderTable /deep/ td {
        font-size: 18px;
        color: #333333;
        letter-spacing: 1px;
    }

    #orderTable /deep/ td > .cell {
        @row();
        height: 60px;
    }

    #orderTable /deep/ th {
        height: 80px;
        background-color: #f5f5f5;
        font-family: MicrosoftYaHei-Bold;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        // @row();
        padding: 0 !important;
    }

    #orderTable /deep/ th > .cell {
        text-align: center;
        overflow: initial;
        @row();
        height: 80px;
    }

    .cert {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: @a;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .table {
            width: @a;
            height: auto;
            margin-top: 38px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/vip/myOrder.vue